import React from 'react';
import { Link } from 'react-router-dom';

import { getIsUserLoggedIn } from '../../../utils/cookie';
import { ROUTES } from '../../../constants';

type Props = {
  pathName: string,
  path: string,
  isLastPath: boolean,
  onClickOnlineOrderLink: Function,
};

function BreadCrumbItem(props: Props) {
  const { pathName, path, isLastPath, onClickOnlineOrderLink } = props;
  if (isLastPath) {
    return (
      <li className="breadcrumb__item">
        <span
          data-automation-id={`breadcrumb-${pathName}`}
          className="u__text--dark"
        >
          {pathName}
        </span>
      </li>
    );
  }

  if (path === '/') {
    return (
      <li className="breadcrumb__item">
        <a
          className="breadcrumb__link"
          data-automation-id="breadcrumb-myAccount"
          href="/"
        >
          Home
        </a>
      </li>
    );
  }

  if (path === '/order/view' && getIsUserLoggedIn()) {
    return (
      <li className="breadcrumb__item">
        <a
          className="breadcrumb__link"
          data-automation-id="breadcrumb-myAccount"
          href={ROUTES.PATH.ACCOUNT_PROFILE}
        >
          My Account
        </a>
      </li>
    );
  }

  if (ROUTES.BREADCRUMB[path] === 'Online Orders') {
    return (
      <li className="breadcrumb__item">
        <span
          aria-hidden
          role="button"
          className="u__default-link"
          onClick={onClickOnlineOrderLink}
          data-automation-id={`breadcrumb-${pathName}`}
        >
          {pathName}
        </span>
      </li>
    );
  }

  return (
    <li className="breadcrumb__item">
      <Link
        className="breadcrumb__link"
        data-automation-id={`breadcrumb-${pathName}`}
        to={path}
      >
        {pathName}
      </Link>
    </li>
  );
}

export default BreadCrumbItem;
